import { render, staticRenderFns } from "./ModalDeleteTerm.vue?vue&type=template&id=613a400b"
import script from "./ModalDeleteTerm.vue?vue&type=script&lang=js"
export * from "./ModalDeleteTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports